import type {ReactElement} from 'react';
import React from 'react';
import type {TextSize} from '../../../text';
import {Text} from '../../../text';
import styles from './student-login-info-text.module.scss';

interface StudentLoginInfoTextProps {
  textSize: TextSize;
  isPanelScreen?: boolean;
}

function StudentLoginInfoText({textSize, isPanelScreen = false}: StudentLoginInfoTextProps): ReactElement {
  const getTeacherLoginMessage = (): string => {
    const linkClass = `${styles.link} ${styles.linkBold} hover-transition-all`;
    if (isPanelScreen) {
      return window.i18next.t('pmwjs_teacher_login_message_mobile', {linkClass});
    }
    return window.i18next.t('pmwjs_teacher_login_message', {linkClass});
  };

  /**
   * The two sentences read as one paragraph, so they are joined rather than stacked. The small-screen
   * panel carries its own combined message and has no classroom link to append.
   */
  const getInfoText = (): string => {
    if (isPanelScreen) {
      return getTeacherLoginMessage();
    }

    const classroomInfo = window.i18next.t('pmwjs_student_login_classroom_info', {
      link: window.PMW.util.site_url('edu'),
      linkClass: `${styles.link} hover-transition-all`,
    });
    return `${getTeacherLoginMessage()} ${classroomInfo}`;
  };

  return <Text val={getInfoText()} size={textSize} dangerouslySetInnerHTML className={styles.text} />;
}

export default React.memo(StudentLoginInfoText);
